
export const DefaultAppTitle = "ClubIntel";
export const VersionDocumentacion = "v3";
export const VersionContratos = "v1";
export const VersionClausulasLegales = "2023-01-01"
export const RecaptchaSiteKey = "6LeL9QAkAAAAAPHSjEICZqcMIQLiG0o07CBoHzPG";

